<template>
	<div class="wrapper news-page">
		<!-- Header -->
		<Header />
		<!-- HeaderMenu -->
		<HeaderMenu />

		<div class="contents">
			<div class="layout">
				<div class="left">
					<div class="pc-only">
						<Sidebar />
					</div>
				</div>
				<div class="right">
					<h1>{{ $t("NEWS") }}</h1>
					<ul class="news-list">
						<li v-for="news in NEWS_ITEM" v-bind:key="news.id">
							<router-link
								:to="`news/${news.id}`"
								class="link-over"
							>
								<div class="date">
									{{ news.date }}
									<span v-if="news.newsFlag === true"
										>NEW</span
									>
								</div>
								<h2>{{ news.title }}</h2>
								<div class="description">
									{{ news.description }}
								</div>
							</router-link>
						</li>
					</ul>
					<div class="pager">
						<span class="prev">
							<a href="#" class="link-over">
								<img
									src="../assets/img/left-arrow-img.png"
									alt=""
								/>
							</a>
						</span>
						<span class="page-item active"
							><a href="#" class="link-over">1</a></span
						>
						<span class="page-item"
							><a href="#" class="link-over">2</a></span
						>
						<span class="page-item"
							><a href="#" class="link-over">3</a></span
						>
						<span class="next">
							<a href="#" class="link-over">
								<img
									src="../assets/img/right-arrow-img.png"
									alt=""
								/>
							</a>
						</span>
					</div>
				</div>
			</div>
		</div>
		<!-- /.contents -->

		<Footer title="NewsList" />
	</div>
</template>
<style scoped></style>
<script>
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
export default {
	name: "Authentication",
	components: {
		Header,
		HeaderMenu,
		Sidebar,
		Footer,
	},
	data: () => {
		return {
			title: "NewsList",
			NEWS_ITEM: [
				{
					id: 1,
					date: "2022.01.10",
					newsFlag: true,
					title: "タイトルタイトル",
					link: "/news",
					description:
						"テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト",
				},
				{
					id: 2,
					date: "2022.01.10",
					newsFlag: false,
					title: "タイトルタイトル",
					link: "/news",
					description:
						"テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト",
				},
				{
					id: 3,
					date: "2022.01.10",
					newsFlag: false,
					title: "タイトルタイトル",
					link: "/news",
					description:
						"テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト",
				},
				{
					id: 4,
					date: "2022.01.10",
					newsFlag: false,
					title: "タイトルタイトル",
					link: "/news",
					description:
						"テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト",
				},
			],
		};
	},
	methods: {},
	computed: {},
	mounted: function () {},
};
</script>
